import type { ReactNode } from 'react';
import { MessageBrand } from '../components/common';
import { G } from './glyphs';
import { CUSTOMER_HOME, CUSTOMER_INFO } from './landing';

// The customer app's shell: the mark and the household's initials at the top,
// the page in the middle, the bar on the foot (G13). One shell for Home and
// Info, so the bar can never drift between them.

export type BarCell = 'stays' | 'info';

function initials(name: string): string {
  return name.split(/\s+/).slice(0, 2).map((w) => w[0] ?? '').join('').toUpperCase();
}

/**
 * THE BAR IS THREE CELLS — Stays · Book · Info — Book the only filled one
 * (decision 127 as Freddi amended it on 2026-10-09, AC1; deviation 17). It was
 * four: the Dogs cell came off and its rows moved into Info whole, because a
 * tab for a list a customer reads twice a year was a tab too many. The
 * fourth cell before that was *You*, while the app had nowhere else to sign
 * out from; the account moved into Info with the rest of that sheet (AC9).
 */
export function CustomerBar({ on, onBook, onGo }: { on: BarCell; onBook: () => void; onGo: (path: string) => void }) {
  const cell = (key: BarCell, path: string, icon: ReactNode, label: string) => (
    <button type="button" className={on === key ? 'on' : ''} aria-current={on === key ? 'page' : undefined} onClick={() => onGo(path)}>
      {icon}
      {label}
    </button>
  );
  return (
    <nav className="cp-bar">
      {cell('stays', CUSTOMER_HOME, G.home({ size: 19 }), 'Stays')}
      <button type="button" className="book" onClick={onBook}>
        {G.calendar({ size: 19 })}
        Book
      </button>
      {cell('info', CUSTOMER_INFO, G.info({ size: 19 }), 'Info')}
    </nav>
  );
}

export function CustomerPage({ on, contactName, onBook, onGo, children }: { on: BarCell; contactName: string; onBook: () => void; onGo: (path: string) => void; children: ReactNode }) {
  return (
    <div className="cp-app cp-home">
      <header className="cp-top">
        <MessageBrand />
        <span className="cp-avatar">{initials(contactName)}</span>
      </header>
      <main className="cp-scroll">{children}</main>
      <CustomerBar on={on} onBook={onBook} onGo={onGo} />
    </div>
  );
}
